import { render, staticRenderFns } from "./SelectedItemsBlock.vue?vue&type=template&id=4341ab2b"
import script from "./SelectedItemsBlock.vue?vue&type=script&lang=js"
export * from "./SelectedItemsBlock.vue?vue&type=script&lang=js"
import style0 from "./SelectedItemsBlock.vue?vue&type=style&index=0&id=4341ab2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports